<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="dateFormatted"
        label="Datum"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      locale="de"
      no-title
      first-day-of-week="1"
      @change="saveDate(date)"
    >
      <v-spacer />
    </v-date-picker>
  </v-menu>
</template>
<script>
// Date
import { format } from "fecha";
import { setGlobalDateI18n } from "fecha";

export default {
  data: () => ({
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
  }),
  computed: {
    dateFormatted() {
      setGlobalDateI18n({
        dayNames: [
          "Sonntag",
          "Montag",
          "Dienstag",
          "Mittwoch",
          "Donnerstag",
          "Freitag",
          "Samstag",
        ],
      });
      return format(new Date(this.date), "dddd DD.MM.YYYY");
    },
  },
  mounted() {
    this.$emit("update", this.date);
  },

  methods: {
    saveDate(date) {
      this.$refs.menu.save(date);
      this.$emit("update", date);
    },
  },
};
</script>
